<template>
  <div class="h-full shrink-0 border-r border-gray-100 bg-white shadow-sm sm:inline-block z-20" :class="{
    'absolute w-full shadow-xl': takeAll,
    'relative': !takeAll,
    '!w-64 inline-block': !takeAll && expanded, 
    'w-16 hidden': !expanded }">
    <div class="relative flex h-20 w-full items-center justify-center border-b border-gray-100 bg-white p-3">
      <img v-if="!expanded" src="@/assets/favicon.png" class="max-w-full max-h-full inline-block"/>
      <img v-else src="@/assets/logo.png" class="max-w-full max-h-full inline-block"/>
      <button
        v-if="expanded"
        type="button"
        class="absolute bottom-2 right-2 !rounded-md !border-0 !bg-gray-100 !p-1.5 !text-gray-700 !shadow-none hover:!bg-primary hover:!text-white"
        aria-label="Navigation einklappen"
        @click="expanded = false; takeAll = false"
      >
        <font-awesome-icon icon="arrow-left" class="text-base" />
      </button>
    </div>

    <div :class="expanded ? 'space-y-0.5 px-3' : 'space-y-0.5 text-center'">
      <font-awesome-icon v-if="!expanded" icon="bars" class="text-2xl text-primary cursor-pointer" @click="expanded = true" />
      <div class="w-full">
        <router-link to="/" class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10" :class="title === 'Home' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'" @click="afterNav()">
          <font-awesome-icon icon="home" class="w-7" :class="title === 'Home' ? 'text-primary' : 'text-black'" />
          <span v-if="expanded" class="ml-1 text-base font-bold">{{ $t('Home') }}</span>
        </router-link>
      </div>
      
      <div v-if="user.subaccount == false" class="w-full" >
        <router-link to="/mydata" class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10" :class="title === 'Meine Daten' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'" @click="afterNav()">
          <font-awesome-icon icon="address-card" class="w-7" :class="title === 'Meine Daten' ? 'text-primary' : 'text-black'" />
          <span v-if="expanded" class="ml-1 text-base font-bold">{{ $t('Meine Daten') }}</span>
        </router-link>
      </div>
      <div v-if="user.subaccount == false && user.anyContract" class="w-full" >
        <router-link to="/services" class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10" :class="title === 'Meine Leistungen' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'" @click="afterNav()">
          <font-awesome-icon icon="file-contract" class="w-7" :class="title === 'Meine Leistungen' ? 'text-primary' : 'text-black'" />
          <span v-if="expanded" class="ml-1 text-base font-bold">{{ $t('Meine Leistungen') }}</span>
        </router-link>
      </div>
      <div v-if="!user.user || user.subaccount == false"  class="w-full" >
        <router-link to="/book" class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10" :class="title === 'Leistung buchen' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'" @click="afterNav()">
          <font-awesome-icon icon="cart-shopping" class="w-7" :class="title === 'Leistung buchen' ? 'text-primary' : 'text-black'" />
          <span v-if="expanded" class="ml-1 text-base font-bold">{{ $t('Leistung buchen') }}</span>
        </router-link>
      </div>
      <div v-if="user.mealplan" class="w-full">
        <router-link to="/cards" class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10" :class="title === 'Mensakarten' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'" @click="afterNav()">
          <font-awesome-icon icon="credit-card" class="w-7" :class="title === 'Mensakarten' ? 'text-primary' : 'text-black'" />
          <span v-if="expanded" class="ml-1 text-base font-bold">{{ $t('Mensakarten') }}</span>
        </router-link>
      </div>
      <div v-if="user.mealplan" class="w-full">
        <router-link to="/mealplanning" class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10" :class="title === 'Essensplanung' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'" @click="afterNav()">
          <font-awesome-icon icon="utensils" class="w-7" :class="title === 'Essensplanung' ? 'text-primary' : 'text-black'" />
          <span v-if="expanded" class="ml-1 text-base font-bold">{{ $t('Essensplanung') }}</span>
        </router-link>
      </div>
      <div v-if="user.subaccount == false && user.pickup" class="w-full">
        <router-link to="/pickup" class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10" :class="title === 'Abholung' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'" @click="afterNav()">
          <font-awesome-icon icon="person-walking-dashed-line-arrow-right" class="w-7" :class="title === 'Abholung' ? 'text-primary' : 'text-black'" />
          <span v-if="expanded" class="ml-1 text-base font-bold">{{ $t('Abholung') }}</span>
        </router-link>
      </div>
      <div v-if="user.ehrenamt" class="w-full">
        <router-link to="/ehrenamt" class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10" :class="title === 'Ehrenamt' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'" @click="afterNav()">
          <font-awesome-icon icon="hand-holding-heart" class="w-7" :class="title === 'Ehrenamt' ? 'text-primary' : 'text-black'" />
          <span v-if="expanded" class="ml-1 text-base font-bold">{{ $t('Ehrenamt') }}</span>
        </router-link>
      </div>
    </div>

    <div class="absolute left-0 bottom-0 w-full text-center">
      <a v-if="user.hasRealAccount" :href="`${backend}/changepw`">
        <button v-if="expanded" class="full">{{ $t('Passwort ändern') }}</button>
        <font-awesome-icon v-else class="text-3xl text-red-300 cursor-pointer mb-2" icon="key" />
      </a>
      <div class="mt-2" >
        <div v-if="expanded && user.user" >
          <button class="full" @click="logout">{{ $t('Abmelden') }}</button><br>
        </div>
        <button v-else-if="expanded" class="full" @click="window.location.href = '/login'">{{ $t('Anmelden') }}</button>
        <font-awesome-icon v-else-if="!expanded && user.user" class="text-3xl text-red-300 cursor-pointer" @click="logout" icon="right-from-bracket" />
        <font-awesome-icon v-else-if="!expanded" class="text-3xl text-red-300 cursor-pointer" icon="user" @click="window.location.href = '/login'"/>
      </div>
      <div v-if="expanded" class="text-center">
        <router-link v-if="user.user && !user.ehrenamt" to="/ehrenamt" @click="afterNav()" class="text-black font-bold border-b-2 border-primary text-sm mt-2 inline-block">{{ $t('Ehrenamtlich unterstützen?') }}</router-link><br>  
        <router-link v-if="user.user" to="/account" class="underline text-black font-bold text-sm mt-2 inline-block">{{ $t('Account löschen') }}</router-link><br>
        <a href="https://www.ev-angel-isch.de/impressum-2/" class="text-sm mx-3 underline cursor-pointer text-gray-500 font-bold" target="_blank" rel="noopener">{{ $t('Impressum') }}</a>
        <a href="https://www.ev-angel-isch.de/datenschutz/" class="text-sm mx-3 underline cursor-pointer text-gray-500 font-bold" target="_blank" rel="noopener">{{ $t('Datenschutz') }}</a>
      </div>
      <div v-if="expanded" class="text-xs text-gray-400 font-semibold mt-1 mb-2">
        Version {{ version }}
      </div>
    </div>
  </div>
</template>
  
<script>
// @ is an alias to /src
import API from "@/API"

export default {
  name: 'Header',
  props: ['title', 'user'],
  data() {
    return {
      backend: process.env.VUE_APP_EVLINE_URL,
      expanded: true,
      takeAll: false,
      window: window,
      version: process.env.VUE_APP_VERSION,
      largeScreen: window.innerWidth > 1024,
    }
  },
  exposes: ['toggle'],
  methods: {
    afterNav(){
      if(!this.largeScreen){
        this.expanded = false
      }
    },
    toggle(takeAll = false) {
      console.log("toggling")
      this.takeAll = takeAll
      this.expanded = !this.expanded
    },
    logout() {
      window.location = process.env.VUE_APP_BE_URL+"/online/auth/logout";
    }
  }, created() {
    // dont expand if screen is small
    if (!this.largeScreen) {
      this.expanded = false;
    }
  }
}
</script>
  